<template>
  <div>
    <div class="flex-around-center">
      <div class="w50" align="center">
        <img v-if="!empty(data.image)" :src="$imgRoot+'/'+data.image" :title="data.title" height="45px" />
        <span v-else>{{data.title}}</span>
      </div>
      <div class="w50" align="center">
        <div class="flex-around-center">
          <span v-for="(item,index) in navList" :key="index" class="navItem pointer" @click="onHandleClick(item.url)"
            :class="$route.meta.tag==item.url?'active':''">{{item.title}}</span>
          <span class="userIcon pointer">
            <img src="@/assets/tubiao01.png" />
            <div class="userTool">
              <div v-if="username" class="disabled">{{username}}</div>
              <div v-if="userinfo" @click="login()" class="hasAnimate">修改或完善信息</div>
              <div v-if="userinfo" @click="toNote()" class="hasAnimate">投稿记录</div>
              <div v-if="userinfo" @click="quit()" class="hasAnimate">退出</div>
              <div v-if="!userinfo" @click="login()" class="hasAnimate">登录</div>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        username: '',
        navList: [],
        userinfo: JSON.parse(sessionStorage.getItem("userInfo")) || null,
        data: {
          image: "",
          title: "信息加载中..."
        }

      }
    },
    mounted() {
      var vueObj = this;
      this.navList = window.config.navList;
      this.$nextTick(function () {
        vueObj.$axios.get("/web/index/webtitle").then(res => {
          if (res.code == 0) {
            vueObj.$set(vueObj, "data", res.data);
          }
        });
        vueObj.updateUserInfo();
      });
    },
    methods: {
      //登录弹窗
      login() {
        this.$router.push("/userInfo");
      },
      //用户退出
      quit() {
        this.$confirm('确定要退出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post("/admin/logout/token", {
            token: this.userinfo.access_token
          }).then(res => {
            if (res.code == 0) {
              sessionStorage.removeItem("userInfo");
              sessionStorage.removeItem("reback");
              this.username = "";
              this.$message.success("已退出");
              this.updateUserInfo();
              setTimeout(() => {
                this.$router.replace("/index");
              }, this.waitTime);
            }
          })
        }).catch(() => {})
      },
      updateUserInfo() {
        this.userinfo = JSON.parse(sessionStorage.getItem("userInfo")) || null;
        if (this.userinfo) {
          this.getUserInfo();
        }
      },
      //跳转页面
      onHandleClick(url) {
        this.$router.push(url);
      },
      //投稿记录
      toNote() {
        this.$router.push("/note");
      },
      //获取用户信息
      getUserInfo() {
        this.$axios.get("/web/user/info").then(res => {
          if (res.code == 0) {
            this.username = res.data.username;
            sessionStorage.setItem("reback", JSON.stringify(res.data));
          }
        })
      },
    },
    watch: {
      "$route"(to) {
        this.updateUserInfo();
      }
    }
  }
</script>

<style scoped>
  .w50 {
    width: 50%;
  }

  .w50>.flex-around-center {
    width: 55%;
    min-width: 375px;
  }

  .navItem {
    /* margin-right: 10%; */
    padding: 5px 22px;
    font-size: 1em;
    line-height: 42px;
    white-space: nowrap;
  }

  .navItem:hover,
  .navItem.active {
    /* color: #B41B15; */
    color: white;
    background: #B41B15;
    /* border-bottom: 2px solid #B41B15; */
  }

  .userIcon {
    display: inline-block;
    position: relative;
  }

  .userTool {
    width: 150px;
    left: -60px;
    position: absolute;
    z-index: 9999;
    background: white;
    border-radius: 10px;
    box-shadow: 0 1px 5px 0 #999999;
    text-align: left;
    opacity: 0;
    transition: .3s all;
    pointer-events: none;
    overflow: hidden;
  }

  .userTool>div {
    line-height: 2em;
    padding: 5px 15px;
    font-size: 0.8em;
  }

  .userIcon:hover>.userTool {
    opacity: 1;
    pointer-events: all;
  }

  .disabled {
    background: #E8E8E8;
  }

  .hasAnimate {
    transition: .5s all;
  }

  .hasAnimate:hover {
    background: #E8E8E8;
  }
</style>


// WEBPACK FOOTER //
// src/views/temp/components/navBody.vue